module.exports = __webpack_public_path__ + "static/img/logo.a38784c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/logo.png
// module id = wZ1Z
// module chunks = 0